export default "__VITE_ASSET__4bda5e25__"